import React, { useState, useEffect } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { NavigationList } from "../../components/navigationList/NavigationList";
import { NavigationListMD } from "../../components/navigationList/NavigationMD";
import { ContentPanel } from "../../components/contentPanel/ContentPanel";
import { ContentCarvajal } from "../../components/contentCarvajal/ContentCarvajal";
import { PanelHeader } from "../../components/panelHeader/PanelHeader";
import { useAuth } from "../../context/AuthContext";
import { Loading } from "../../components/sharedComponents/Loading";
import { useFetchDocument } from "../../hooks/useGetDocument";

export default function Admin() {
  const [selectedItem, setSelectedItem] = useState(0);
  const [menuOpen, setMenuOpen] = useState(true);
  const [documentID, setDocumentID] = useState(null);
  const [nameDocument, setNameDocument] = useState("");
  const [modal, setModal] = useState(false);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { token, user, loading } = useAuth();

  const {
    document: documentsList,
    loading: documentsLoading,
    refetch: refetchDocuments,
  } = useFetchDocument(token);

  useEffect(() => {
    if (documentID === "1000242") {
      setModal(true);
    }
  }, [documentID]);

  return (
    <Grid container style={{ height: "100vh" }}>
      {loading ? (
        <Loading message="Cargando Informacion de Usuario..." />
      ) : (
        <>
          <Grid
            item
            xs={isMdUp ? (!menuOpen ? 1 : 2) : 0}
            style={
              isMdUp
                ? {
                    height: "100%",
                    borderRight: "1px solid rgba(127, 127, 127, 0.5)",
                  }
                : {}
            }
          >
            {isMdUp ? (
              <NavigationList
                menuOpen={menuOpen}
                handleItemClick={(item) => setSelectedItem(item)}
                documentID={documentID}
                setDocumentID={setDocumentID}
                setNameDocument={setNameDocument}
                selectedItem={selectedItem}
                rol={user?.rol}
                documents={documentsList}
                documentsLoading={documentsLoading}
              />
            ) : (
              <NavigationListMD
                menuOpen={menuOpen}
                handleItemClick={(item) => setSelectedItem(item)}
                handleMenuToggle={() => setMenuOpen(!menuOpen)}
                documentID={documentID}
                setDocumentID={setDocumentID}
                setNameDocument={setNameDocument}
                selectedItem={selectedItem}
                rol={user?.rol}
                documents={documentsList}
                documentsLoading={documentsLoading}
              />
            )}
          </Grid>
          <Grid
            item
            xs={isMdUp ? (!menuOpen ? 11 : 10) : 12}
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              padding: "20px",
            }}
          >
            <div style={{ height: "6%" }}>
              <PanelHeader
                handleMenuToggle={() => setMenuOpen(!menuOpen)}
                nameDocument={nameDocument}
                userMe={user}
              />
            </div>
            <div style={{ height: "94%" }}>
              <ContentPanel
                selectedItem={selectedItem}
                token={token}
                idDocument={documentID}
                rol={user?.rol}
                nameDocument={nameDocument}
                onDocumentsChange={refetchDocuments}
              />
            </div>
          </Grid>
          <ContentCarvajal
            token={token}
            open={modal}
            close={() => {
              setModal(false);
              setDocumentID("1000129");
            }}
            idDocument={documentID}
          />
        </>
      )}
    </Grid>
  );
}
